import type * as Diff from 'diff';
import { isRotation } from './credentialReferences';

export type DiffLineKind = 'same' | 'added' | 'removed' | 'rotated';

export interface DiffLine {
  kind: DiffLineKind;
  text: string;
}

/**
 * The diff as lines. A removed run followed by an added run of the same length,
 * where each pair differs only by the version of the same credentials, is a
 * rotation, not a change of intent: it shows once, as the newer line
 * (website-backend#81).
 */
export function linesOf(parts: Diff.Change[]): DiffLine[] {
  const split = (value: string) => {
    const lines = value.split('\n');
    if (lines[lines.length - 1] === '') lines.pop();
    return lines;
  };
  const out: DiffLine[] = [];
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    const next = parts[i + 1] as Diff.Change | undefined;
    if (part.removed && next?.added) {
      const before = split(part.value);
      const after = split(next.value);
      if (before.length === after.length && before.every((line, k) => isRotation(line, after[k]))) {
        for (const line of after) out.push({ kind: 'rotated', text: line });
        i++;
        continue;
      }
    }
    const kind: DiffLineKind = part.added ? 'added' : part.removed ? 'removed' : 'same';
    for (const line of split(part.value)) out.push({ kind, text: line });
  }
  return out;
}
